import { firebase, googleProvider } from '../plugins/firebase'

export { onAuthStateChanged, googleLogin, signOut }

let onAuthStateChanged = async function(db) {
    return new Promise((resolve, reject) => {
        firebase.auth().onAuthStateChanged(async loggedUser => {
            console.info('onAuthStateChanged')
            try {
              if (loggedUser) {
                let displayName = loggedUser.displayName
                let users = await db.collection('users').doc('register').get()
                let isAdmin = await users.data().admin.includes(loggedUser.uid)
                let isEditor = await users.data().editor.includes(loggedUser.uid)
                if(!displayName) { displayName = loggedUser.email}
                let user = {
                  uid: loggedUser.uid,
                  photoURL: loggedUser.photoURL,
                  displayName: displayName,
                  isAdmin: isAdmin,
                  isEditor: isEditor
                }
                resolve(user)
              } else {
                console.log('No user is signed in')
              }
            }
            catch (e) {
              console.error('Auth Error : ', e)
              reject()
            }
          });
    });
}

let googleLogin = async function(db) {

  return new Promise((resolve, reject) => {
    firebase.auth().signInWithPopup(googleProvider)
    .then(async result => {
        console.info('Sign-in successful')
        let displayName = result.user.displayName
        if(!displayName) { displayName = result.user.email}
        let users = await db.collection('users').doc('register').get()
        let isAdmin = await users.data().admin.includes(result.user.uid)
        let isEditor = await users.data().editor.includes(result.user.uid)
        let user = {
          uid: result.user.uid,
          photoURL: result.user.photoURL,
          displayName: displayName,
          isAdmin: isAdmin,
          isEditor: isEditor
        }
        resolve(user)
      })
    .catch(function(error) {
      console.error(error)
      reject()
    });
  })
}

let signOut = function() {
  return new Promise((resolve, reject) => {
    firebase.auth().signOut().then(() => {
      console.info('Sign-out successful')
      resolve(true)
    }).catch(function(error) {
        console.error(error)
        reject()
    });
  });
}

